__turbopack_context__.v({
  "centered": "GifGrid-module__CfgdAq__centered",
  "grid": "GifGrid-module__CfgdAq__grid",
});
